import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import { WithoutThemeRouteList, FrontRouteList, AdminRoutes, CustomerRoutes, SuperAdminRoutes, RedirectRoutes } from "./index";
import AdminLayout from "../layouts/AdminLayout";
import CustomerLayout from "../layouts/CustomerLayout";
import PageNotFound from "../frontend/pages/page-not-found/PageNotFound";
import Loader from "../admin/components/Loader";
import { useWebsite } from "../context/WebsiteContext";

const MainRoutes = () => {
  const { domainNotFound, loading, websiteData } = useWebsite();

  // Only the main domain and domains registered to a company may use the app
  if (domainNotFound) return <PageNotFound unknownDomain={true} />;

  // Wait for the domain check so an unknown subdomain never mounts the dashboard/login first
  if (loading && !websiteData) return <Loader open={true} setOpen={() => {}} />;

  return (<Router>
    <Routes>
      {WithoutThemeRouteList?.map(({ component: Component, path }, index) => {
        return (<Route key={index} path={path} exact element={<Component />} />);
      })}

      {FrontRouteList?.map(({ component: Component, path }, index) => {
        return (<Route key={index} path={path} exact element={<Component />} />);
      })}

      {CustomerRoutes?.routeList?.map(({ component: Component, path, feature }, index) => {
        return (<Route key={index} path={`/customer${path}`} exact element={<CustomerLayout><Component userScope={"Customer"} feature={feature} /></CustomerLayout>} />);
      })}

      {AdminRoutes?.routeList?.map(({ component: Component, path, menuName, permission, feature }, index) => {
        return (<Route key={index} path={`${path}`} exact element={<AdminLayout><Component menuName={menuName} userScope={"Admin"} permission={permission} feature={feature} /></AdminLayout>} />);
      })}

      {SuperAdminRoutes?.routeList?.map(({ component: Component, path, menuName }, index) => {
        return (<Route key={`sa-${index}`} path={path} exact element={<AdminLayout><Component menuName={menuName} userScope={"SuperAdmin"} /></AdminLayout>} />);
      })}

      {RedirectRoutes.map(({ path, to }) => {
        return (<Route key={path} path={path} element={<Navigate to={to} replace />} />);
      })}

      <Route path="*" element={<PageNotFound />} />
    </Routes>
  </Router>);
}

export default MainRoutes;
